module.exports = __webpack_public_path__ + "img/product_card_discount_price.09a1084b.png";